import api from "./index";

export interface Prescription {
  id: string;
  name: string;
  description?: string;
  medicines?: {
    id: string;
    prescriptionId: string;
    medicineName: string;
    dosage?: string;
    frequency?: string;
    durationDays?: number;
    instructions?: string;
  }[];
}

export const getAllPrescriptions = async (): Promise<Prescription[]> => {
  const res = await api.get("/prescriptions/getAll");
  const list = res?.data?.data || res?.data || [];
  if (!Array.isArray(list)) return [];
  return list;
};

